var app = angular.module('leonardo');

var ScheduleService = function(BaseRestService, RestangularProvider) {
  var service = new BaseRestService('quick-reports-schedule');

  service.unsubscribe = function (token) {
    return RestangularProvider.all('quick-reports-schedule').customGET('unsubscribe', {token:token});
  };

  return service;
};

app.factory('ScheduleService', ['BaseRestService', 'Restangular', ScheduleService]);
